module.exports = new __parcel__URL__("MeyersMatchupsPortfolioPiece.a636629b.svg").toString();